import BannerAward2024 from '../img/banner/Award2024.png';
import Boxes from '../img/event/2611/boxes.png';
import Title from '../img/event/2611/title.png';
import Background1 from '../img/event/2611/background1.png';
import Background2 from '../img/event/2611/background2.png';
import Flower from '../img/event/2611/flower.png';
import Online_Session from '../img/event/online-session.png';
import { DoubleLineWithCursorButton, DoubleLineButton } from './common/Button';
import React from 'react';
import { TextBox } from './common/TextBox';

const HomeschoolEvent202611 = () => {
  return (
    <>
      {/* 배너 영역 */}
      <img src={BannerAward2024} alt="Award2024" className="m-auto w-full" />

      {/* 프로모션 섹션 1 */}
      <div className="w-full overflow-hidden bg-[#8C5514] leading-none">
        <img src={Background1} alt="" className="-mb-px block h-auto w-full" />
      </div>

      {/* 프로모션 섹션 2 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#8C5514]">
        <div className="flex w-full flex-col px-5 pb-8 sm:px-8 sm:pb-10 md:px-10 md:pb-12 lg:pb-14">
          <div className="mx-auto flex w-full flex-col items-center justify-center">
            <div className="mb-5 flex flex-col items-center text-center sm:mb-7 md:mb-8">
              <div className="mx-auto mb-4 w-full max-w-[330px] pl-[9%] sm:mb-5 sm:max-w-[400px] md:mb-6 md:max-w-[470px] lg:max-w-[540px]">
                <img src={Title} alt="암기 명중" className="block w-full" />
              </div>

              <div>
                <p className="flex flex-col gap-1 text-3xl font-extrabold leading-none text-[#FAEFCE] sm:gap-1 sm:text-4xl md:gap-2 md:text-5xl lg:text-6xl">
                  <span>11월에</span>
                  <span>시작해야 하는 이유!</span>
                </p>
              </div>

              <div className="my-4 sm:my-5">
                <p className="text-sm font-extrabold leading-[1.25] text-[#FAEFCE] sm:text-base md:text-lg lg:text-xl">
                  지금 심어야 내년이 더 열매로워요
                </p>
              </div>

              <div className="mx-auto mb-4 w-full max-w-[330px] sm:mb-5 sm:max-w-[400px] md:mb-6 md:max-w-[470px] lg:max-w-[540px]">
                <img src={Boxes} alt="암기 명중" className="block w-full" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 3 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#FAEFCE]">
        <div className="m-auto flex w-full flex-col px-5 py-10 sm:px-8 sm:py-14 md:px-10 md:py-16 lg:py-20">
          <div className="m-auto flex w-full max-w-[520px] flex-col gap-5 sm:gap-7 md:max-w-[620px] md:gap-8 lg:max-w-[720px]">
            {/* 설명회 타이틀 */}
            <section className="flex flex-col text-center sm:gap-1">
              <div className="text-lg font-semibold text-[#5E5D37] sm:text-xl md:text-2xl lg:text-3xl">
                올해의 감사가 내년의 열매가 되도록
              </div>

              <div className="text-lg font-extrabold leading-snug text-[#000000] sm:text-2xl md:text-3xl lg:text-4xl">
                온라인 설명회에서 직접 확인하세요!
              </div>
            </section>

            {/* 이미지 */}
            <div className="relative m-auto w-full max-w-[360px] sm:max-w-[460px] md:max-w-[560px] lg:max-w-[640px]">
              <img
                src={Online_Session}
                alt="젭스영어교실 온라인설명회"
                className="block w-full"
              />
            </div>

            {/* 버튼 */}
            <div className="mx-auto w-full max-w-[360px] sm:max-w-[460px] md:max-w-[560px] lg:max-w-[640px]">
              <DoubleLineButton
                onClick={() => {
                  window.open('https://forms.gle/hYg6Q4YQ4tMcBFb58');
                }}
                borderColor="border-white"
                bgColor="bg-[#DD7035]"
                hoverBgColor="hover:bg-black/10"
                textColor="text-white"
              >
                <div className="px-4 py-3 text-base font-bold sm:px-5 sm:py-4 sm:text-2xl md:text-3xl lg:text-4xl">
                  지금 설명회 신청하기
                </div>
              </DoubleLineButton>
            </div>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 4 */}
      <div className="flex w-full items-center justify-center overflow-hidden bg-[#DD7035]">
        <div
          className="m-auto -mb-px flex w-full flex-col bg-white bg-top bg-no-repeat px-5 py-10 sm:px-8 sm:py-14 md:px-10 md:py-16 lg:py-20"
          style={{
            backgroundImage: `url(${Background2})`,
            backgroundSize: '100% 100%',
          }}
        >
          <div className="mx-auto w-full max-w-[520px] md:max-w-[620px] lg:max-w-[720px]">
            {/* 상단 문구 */}
            <div className="mb-5 flex flex-col items-center text-center sm:mb-10 md:mb-12">
              <p className="flex flex-col gap-1 text-3xl font-extrabold leading-none text-[#FAEFCE] sm:gap-1 sm:text-4xl md:gap-2 md:text-5xl lg:text-6xl">
                <span>믿음 영어...</span>
                <span>정말 열매 맺을까요?</span>
              </p>
            </div>

            <div className="mb-5 flex flex-col items-center text-center sm:mb-10 md:mb-12">
              <p className="text-base font-bold leading-relaxed text-[#FAEFCE] sm:text-xl md:text-2xl lg:text-3xl">
                직접 삶으로 증명하고 있는
                <br />
                젭스영어교실 선생님들의 이야기를
                <br />
                만나보세요!
              </p>
            </div>
            {/* 하단 박스 */}
            <section className="flex w-full flex-col gap-4 sm:gap-5 md:gap-6">
              <div className="grid grid-cols-1 gap-12 md:gap-14 lg:gap-16">
                <div className="relative">
                  <TextBox className="h-full !bg-[#FFF5E9]">
                    <div className="flex flex-col gap-5 py-4 text-left text-base font-normal leading-relaxed text-black sm:text-xl md:gap-6 md:text-2xl lg:text-3xl">
                      <p>
                        <span className="font-bold text-[#FF6600]">
                          JEMM 최OO 선생님
                        </span>
                      </p>

                      <p className="leading-[1.7]">
                        알파벳도 모르는 아이들과
                        <br />
                        어떻게 시작할지 걱정이었지만,
                        <br />
                        <span className="font-bold">
                          기도하며 만들어진 프로그램이기에
                        </span>
                        <br />
                        <span className="font-bold">
                          하나님께 맡기고 가르쳤습니다.
                        </span>
                      </p>

                      <p className="leading-[1.7]">
                        그런데 아이들이 다른 과에서 배운 문장을
                        <br />
                        <span className="font-bold">
                          스스로 연결해 떠올릴 때마다
                        </span>
                        <br />
                        <span className="font-bold">
                          저도 모르게 깜짝 놀라곤 합니다.
                        </span>
                        <br />
                        아이들이 즐겁게 공부할 수 있음에,
                        <br />
                        젭스를 통해 아이들에게 복음을 전하게 하심에,
                        <br />
                        오늘도 감사합니다.
                      </p>
                    </div>
                  </TextBox>

                  <img
                    src={Flower}
                    alt=""
                    aria-hidden
                    className="pointer-events-none absolute right-4 top-1 z-10 w-[82px] -translate-y-[30%] sm:w-[100px] md:w-[120px] lg:w-[140px]"
                  />
                </div>

                <div className="relative">
                  <TextBox className="h-full !bg-[#FFF5E9]">
                    <div className="flex flex-col gap-5 py-4 text-left text-base font-normal leading-relaxed text-black sm:text-xl md:gap-6 md:text-2xl lg:text-3xl">
                      <p>
                        <span className="font-bold text-[#FF6600]">
                          JEMM 김OO 선생님
                        </span>
                      </p>

                      <p className="leading-[1.7]">
                        교회를 다니지 않던 아이들이
                        <br />
                        <span className="font-bold">
                          "하나님이 만드셨어요"라고 고백하고,
                        </span>
                        <br />
                        발표를 어려워하던 아이가
                        <br />
                        <span className="font-bold">
                          이제는 자신 있게 암송하는 모습을 보며
                        </span>
                        <br />
                        젭스는 단순한 영어교육을 넘어,
                        <br />
                        <span className="font-bold">
                          영어와 신앙을 함께 세우는 귀한 통로
                        </span>
                        라는
                        <br />
                        생각이 듭니다.
                      </p>

                      <p className="leading-[1.7]">
                        <span className="font-bold">
                          '영어교육선교사'라는 사명을 붙잡고,
                        </span>
                        <br />
                        <span className="font-bold">
                          하나님 나라를 함께 확장해 나가길 소망합니다.
                        </span>
                      </p>
                    </div>
                  </TextBox>

                  <img
                    src={Flower}
                    alt=""
                    aria-hidden
                    className="pointer-events-none absolute right-4 top-1 z-10 w-[82px] -translate-y-[30%] sm:w-[100px] md:w-[120px] lg:w-[140px]"
                  />
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      {/* 프로모션 섹션 5 */}
      <div className="flex w-full items-center justify-center bg-[#DD7035]">
        <div className="m-auto flex w-full flex-col bg-[#DD7035] bg-top bg-no-repeat px-5 py-10 sm:px-8 sm:py-14 md:px-10 md:py-16 lg:py-20">
          <div className="mx-auto w-full max-w-[520px] md:max-w-[620px] lg:max-w-[720px]">
            <div className="m-auto flex w-full flex-col px-0 pb-0">
              <div className="flex flex-col gap-4 sm:gap-6 md:gap-8 lg:gap-10">
                <p className="text-center text-base font-extrabold text-white sm:text-xl md:text-2xl lg:text-3xl">
                  올해 받은 감사가
                  <br />
                  내년의 열매가 되도록,
                </p>

                <p className="text-center text-base font-extrabold text-white sm:text-xl md:text-2xl lg:text-3xl">
                  우리 아이 마음에
                  <br />
                  말씀의 씨앗을 심으세요
                </p>

                <p className="text-center text-base font-extrabold text-white sm:text-xl md:text-2xl lg:text-3xl">
                  젭스영어교실
                  <br />
                  11월에 시작하세요!
                </p>
              </div>

              {/* 버튼 */}
              <div className="mx-auto mt-8 w-full max-w-[360px] sm:mt-10 sm:max-w-[520px] md:mt-12 md:max-w-[640px]">
                <DoubleLineWithCursorButton
                  onClick={() => {
                    window.open(
                      'https://jebs.kr/shop/details/NKyRTHjIgiewcumT',
                    );
                  }}
                  bgColor="bg-black"
                  hoverBgColor="hover:bg-black/70"
                  textColor="text-white"
                >
                  <div className="px-4 py-3 text-base font-bold sm:px-6 sm:py-4 sm:text-2xl md:text-3xl lg:px-8 lg:py-5 lg:text-3xl">
                    11월 젭스영어교실&nbsp;
                    <span className="text-[#FDF4B4]">등록하고 혜택 받기</span>
                  </div>
                </DoubleLineWithCursorButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeschoolEvent202611;
